// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2CbeU","inner":"Footer_inner__3Bgyq"};